import React, {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import {useTheme} from '@emotion/react';
import {Link} from 'react-router-dom';
import TablePagination from '@mui/material/TablePagination';
import {CircularProgress} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import PropTypes from 'prop-types';

import Alert, {useAlert} from 'components/snacks/Alert';

import {axiosInstance} from 'api/Api';
import Loading from 'layout/Loading';
import {truncateString} from "helpers/functions";
import Modal from "@mui/material/Modal";
import BasicModal from "components/Modal/BasicModal";

function TablePaginationActions(props) {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    useEffect(() => {
        const selector1 = document.querySelector('#factorPagination p');
        if (selector1) {
            selector1.classList.add('yekan-font');
            selector1.innerHTML = 'ردیف در هر صفحه';
        }
    }, []);

    return (
        <Box sx={{flexShrink: 0, ml: 2.5}}>
            <IconButton
                sx={{mr: 2.5}}
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>

            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft/>
                ) : (
                    <KeyboardArrowRight/>
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight/>
                ) : (
                    <KeyboardArrowLeft/>
                )}
            </IconButton>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

const WalletPage = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [len, setLen] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [bankDetail, setBankDetail] = useState({
        card_number: '5892-1013-0981-0436',
        shaba_number: 'IR840150000003101003635941',
        owner_name: 'فاطمه بقائی فر',
        account: 'بانک س    په'
    });
    const [modalDetail, setModalDetail] = useState({
        show: false,
        loading: false,
        type: 2 // 1 => show bank detail, 2 => get amount and redirect to bank
    });
    const [moreDetail, setMoreDetail] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [increaseAmount, setIncreaseAmount] = useState('');

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);
    const Error = (text, type = 'success') => {
        alertStore.AddAlert({
            key: '400',
            message: text,
            severity: type,
            auto_hide: true
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const copyText = (txt) => {
        navigator.clipboard.writeText(txt);
        return Error('با موفقیت کپی شد', 'success');
    };

    function isNumeric(str) {
        if (typeof str != 'string') return false;
        return !isNaN(str) && !isNaN(parseFloat(str));
    }

    const increaseWallet = () => {
        if (!isNumeric(increaseAmount))
            return Error('لطفا مقدار را درست وارد کنید', 'error');
        //
        setIncreaseAmount(parseFloat(increaseAmount));
        //
        if (increaseAmount < 1000)
            return Error('حداقل مبلغ 1000 تومان است.', 'error');
        //
        setModalDetail({...modalDetail, loading: true});
        const formData = new FormData();
        formData.append('amount', increaseAmount);
        axiosInstance()
            .post('/rial-increase', formData)
            .then((r) => {
                setModalDetail({...modalDetail, loading: false, show: false});
                //
                if (r.data.status === 200) {
                    Error(r.data.msg, 'success');
                    setTimeout(() => {
                        window.location.href = r.data.url;
                    }, 1500);
                } else {
                    return Error(r.data.msg, 'error');
                }
            })
            .catch((e) => {
                setModalDetail({...modalDetail, loading: false, show: false});
                return Error(e.response.data.msg, 'error');
            });
    };

    const increaseAmountInputHandler = (e) => {
        if (e.keyCode === 13) {
            increaseWallet();
        }
    };

    // MOUNTED
    useEffect(() => {
        setLoading(true);
        axiosInstance()
            .get('/get-accounting')
            .then((r) => {
                const data = r.data;
                if (data.status === 200) {
                    setData(data.acc_detail);
                    setLen(data.acc_detail.length);
                    setModalDetail({...modalDetail, type: data.user_type});
                    setBankDetail({
                        card_number: data.card_no,
                        shaba_number: data.shaba_no,
                        owner_name: data.account_name,
                        account: data.account
                    });
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);
    //
    const handelMoreDetail = (row) => {
        setSelectedRow(row)
        setMoreDetail(true)
    }
    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    <Paper
                        className="normal-shadow rounded bg-white my-5"
                        id={'serviceCard'}
                        elevation={1}
                        sx={{overflow: 'hidden', padding: '20px 35px'}}
                    >
                        <div
                            className="card-header d-flex justify-content-between align-items-center py-3 gap-2 gap-md-5 w-100"
                            data-select2-id="select2-data-133-8g4r"
                        >
                            <div className="card-title w-100">
                                <div
                                    className="d-flex align-items-center justify-content-between position-relative my-1 w-100">
                                    <h6 className={'m-0'}>تراکنش های ریالی</h6>

                                    <button
                                        className={'btn btn-sm btn-primary'}
                                        onClick={() =>
                                            setModalDetail({...modalDetail, show: true})
                                        }
                                    >
                                        افزایش موجودی
                                    </button>
                                </div>
                            </div>
                        </div>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead sx={{BackgroundColor: '#eaeaea'}}>
                                    <TableRow>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            ردیف
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            توضیحات
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            تاریخ
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            بدهکار
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            بستانکار
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            مانده
                                        </TableCell>
                                        <TableCell
                                            align={'right'}
                                            style={{
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            مشاهده جزئیات
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={index}
                                                    style={{
                                                        backgroundColor: index % 2 === 0 ? '#f0f6ff' : ''
                                                    }}
                                                >
                                                    <TableCell
                                                        align={'right'}

                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span>{index + 1 + page * rowsPerPage}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className={'w-25'}
                                                        align={'right'}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span title={row.description}>
                                                            {truncateString(row.description, 50)}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        style={{direction: 'ltr'}}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span>{row.created_at}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        style={{direction: 'ltr'}}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span>{Number(row.debit).toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        style={{direction: 'ltr'}}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span>{Number(row.credit).toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        style={{direction: 'ltr'}}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        <span>{Number(row.remain).toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        sx={{fontFamily: 'yekan !important'}}
                                                    >
                                                        {row.ref_id === '0' ? (
                                                            <p>-</p>
                                                        ) : (
                                                            <>
                                                                <button onClick={() => handelMoreDetail(row)}
                                                                    className={'text-primary border-none bg-transparent'}
                                                                >
                                                                    <span className={'me-2'}>مشاهده</span>
                                                                    <span
                                                                        className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{transform: 'rotate(180deg)'}}
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                      <rect
                                          opacity="0.5"
                                          x="18"
                                          y="13"
                                          width="13"
                                          height="2"
                                          rx="1"
                                          transform="rotate(-180 18 13)"
                                          fill="#009ef7"
                                      />
                                      <path
                                          d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                          fill="#009ef7"
                                      />
                                    </svg>
                                  </span>
                                                                </button>
                                                            </>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TableContainer>
                            <Table>
                                <TableHead/>
                                <TableBody>
                                    <TableRow>
                                        <TablePagination
                                            id={'factorPagination'}
                                            rowsPerPageOptions={[
                                                5,
                                                10,
                                                25,
                                                {label: 'All', value: 1000}
                                            ]}
                                            colSpan={4}
                                            count={len}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                inputProps: {
                                                    'aria-label': 'rows per page'
                                                },
                                                native: true
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                            style={{display: 'flex'}}
                                        />
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                    {/* ******************* MODAL ***************************** */}
                    {modalDetail.show && (
                        <>
                            <div className="modal fade show d-block" id="transferModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                                افزایش موجودی
                                            </h1>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() =>
                                                    setModalDetail({
                                                        ...modalDetail,
                                                        show: false
                                                    })
                                                }
                                            ></button>
                                        </div>
                                        {modalDetail.loading ? (
                                            <>
                                                <div className="modal-body text-center">
                                                    <Box
                                                        sx={{display: 'flex', marginLeft: '15px'}}
                                                        className={'mx-auto'}
                                                    >
                                                        <CircularProgress className={'mx-auto'}/>
                                                    </Box>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="modal-body">
                                                    {modalDetail.type === 1 ? (
                                                        <>
                                                            <p className="m-0">
                                                                برای افزایش موجودی، مبلغ مورد نظر خود را به حساب
                                                                زیر واریز نمایید.
                                                            </p>
                                                            <div className="text-center mt-5">
                                                                <h5 className={'badge badge-primary w-100'}>
                                                                    شماره کارت
                                                                </h5>
                                                                <div
                                                                    className={
                                                                        'd-flex justify-content-between align-items-center'
                                                                    }
                                                                >
                                                                    <button
                                                                        onClick={() =>
                                                                            copyText(bankDetail.card_number)
                                                                        }
                                                                        className={'btn btn-sm'}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="16"
                                                                            height="16"
                                                                            fill="currentColor"
                                                                            className="bi bi-clipboard"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                                                            <path
                                                                                d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                                                        </svg>
                                                                    </button>
                                                                    <h4 className={'m-0 ms-2'}>
                                                                        {bankDetail.card_number}
                                                                    </h4>
                                                                </div>
                                                                <h5
                                                                    className={'badge badge-primary mt-3 w-100'}
                                                                >
                                                                    شماره شبا
                                                                </h5>
                                                                <div
                                                                    className={
                                                                        'd-flex justify-content-between align-items-center'
                                                                    }
                                                                >
                                                                    <button
                                                                        onClick={() =>
                                                                            copyText(bankDetail.shaba_number)
                                                                        }
                                                                        className={'btn btn-sm'}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="16"
                                                                            height="16"
                                                                            fill="currentColor"
                                                                            className="bi bi-clipboard"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                                                            <path
                                                                                d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                                                        </svg>
                                                                    </button>
                                                                    <h4 className={'m-0 ms-2'}>
                                                                        {bankDetail.shaba_number}
                                                                    </h4>
                                                                </div>
                                                                <h5
                                                                    className={'badge badge-primary mt-3 w-100'}
                                                                >
                                                                    به نام
                                                                </h5>
                                                                <div
                                                                    className={
                                                                        'd-flex justify-content-between align-items-center'
                                                                    }
                                                                >
                                                                    <h4 className={'m-0 ms-2'}>
                                                                        {bankDetail.owner_name}
                                                                    </h4>
                                                                    <h4 className={'m-0'}>
                                                                        {bankDetail.bank_name}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="m-0">
                                                                برای افزایش موجودی، مبلغ مورد نظر خود را وارد
                                                                نمایید.
                                                            </p>
                                                            <input
                                                                type="number"
                                                                className={'form-control mt-5'}
                                                                placeholder={'مبلغ'}
                                                                onKeyDown={(e) => increaseAmountInputHandler(e)}
                                                                onChange={(e) =>
                                                                    setIncreaseAmount(e.target.value)
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                                {modalDetail.type === 2 && (
                                                    <div
                                                        className={
                                                            'modal-footer d-flex justify-content-between align-items-center'
                                                        }
                                                    >
                                                        <h5>
                                                            {increaseAmount && (
                                                                <>
                                                                    {Number(increaseAmount).toLocaleString()}{' '}
                                                                    تومان{' '}
                                                                </>
                                                            )}
                                                        </h5>
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mx-3"
                                                                onClick={() =>
                                                                    setModalDetail({
                                                                        ...modalDetail,
                                                                        show: false
                                                                    })
                                                                }
                                                            >
                                                                انصراف
                                                            </button>
                                                            <button
                                                                type={'button'}
                                                                className={'btn btn-success'}
                                                                onClick={increaseWallet}
                                                            >
                                                                پرداخت
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="modal-backdrop fade show"
                                onClick={() =>
                                    setModalDetail({
                                        ...modalDetail,
                                        show: false
                                    })
                                }
                            ></div>
                        </>
                    )}

                    {/* ******************* Show detail MODAL ***************************** */}

                        <BasicModal
                        open={moreDetail}
                        setOpen={setMoreDetail}
                        headTitle={`جزئیات تراکنش شماره ${selectedRow.id}`}
                        >
                            <Box className={'d-flex flex-column gap-1'}>
                                <div className={'d-flex items-center border-bottom'}>
                                    <div className={'w-25 p-2 font-bold border-left'} style={{
                                        backgroundColor: 'rgb(240, 246, 255)'
                                    }}>تاریخ</div>
                                    <div className={'w-75 p-2'}>{selectedRow.created_at}</div>
                                </div>
                                <div className={'d-flex items-center border-bottom'}>
                                    <div className={'w-25 p-2 font-bold border-left'} style={{
                                        backgroundColor: 'rgb(240, 246, 255)'
                                    }}>بستانکار</div>
                                    <div className={'w-75 p-2 text-start'} dir={'ltr'}>{selectedRow.credit}</div>
                                </div>
                                <div className={'d-flex items-center border-bottom'}>
                                    <div className={'w-25 p-2 font-bold border-left'} style={{
                                        backgroundColor: 'rgb(240, 246, 255)'
                                    }}>بدهکار</div>
                                    <div className={'w-75 p-2 text-start'} dir={'ltr'}>{selectedRow.debit}</div>
                                </div>
                                <div className={'d-flex items-center border-bottom'}>
                                    <div className={'w-25 p-2 font-bold border-left'} style={{
                                        backgroundColor: 'rgb(240, 246, 255)'
                                    }}>باقی مانده</div>
                                    <div className={'w-75 p-2 text-start'} dir={'ltr'}>{selectedRow.remain}</div>
                                </div>
                                <div className={'d-flex items-center border-bottom'}>
                                    <div className={'w-25 p-2 font-bold border-left'} style={{
                                        backgroundColor: 'rgb(240, 246, 255)'
                                    }}>توضیحات</div>
                                    <div className={'w-75 p-2'}>{selectedRow.description}</div>
                                </div>
                            </Box>
                        </BasicModal>
                </>
            )}
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    );
};

export default WalletPage;
